import { useContext } from "react";

import { GlobalLoadingContext } from "Contexts/GlobalLoading";

export const UseGlobalLoading = () => {
  const {
    loading,
    setLoading,
    usePercentage,
    setUsePercentage,
    percentage,
    setPercentage,
    useStep,
    setUseStep,
    step,
    setStep,
  } = useContext(GlobalLoadingContext);

  return {
    loading,
    setLoading,
    usePercentage,
    setUsePercentage,
    percentage,
    setPercentage,
    useStep,
    setUseStep,
    step,
    setStep,
  };
};
